import React from "react";
import { useTip } from "../ui/Tooltip/Tooltip";
import { CHART_COLORS } from "../../styles/theme";

/**
 * Courbe d'évolution avec aire et points.
 * points : number[] ; tips : string[] (un par point)
 */
const Sparkline = ({
    points = [],
    width = 392,
    height = 100,
    color = CHART_COLORS.violet,
    fill = true,
    tips = [],
}) => {
    const tip = useTip();
    const max = Math.max(...points);
    const min = Math.min(...points);
    const range = max - min || 1;

    const xy = points.map((p, i) => [
        8 + (i * (width - 16)) / (points.length - 1),
        height - 14 - ((p - min) / range) * (height - 30),
    ]);
    const d = xy
        .map((p, i) => `${i ? "L" : "M"}${p[0].toFixed(1)} ${p[1].toFixed(1)}`)
        .join(" ");
    const area = `${d} L${xy[xy.length - 1][0].toFixed(1)} ${
        height - 6
    } L${xy[0][0].toFixed(1)} ${height - 6} Z`;

    return (
        <svg viewBox={`0 0 ${width} ${height}`} width="100%" height={height}>
            {fill && <path d={area} fill={color} opacity=".1" />}
            <path d={d} fill="none" stroke={color} strokeWidth="2" />
            {/* zones de survol (invisibles, plus larges) */}
            {xy.map((p, i) => (
                <circle
                    key={`hit-${i}`}
                    cx={p[0].toFixed(1)}
                    cy={p[1].toFixed(1)}
                    r="5"
                    fill={color}
                    style={{ opacity: 0 }}
                    {...tip(tips[i])}
                />
            ))}
            {xy.map((p, i) => (
                <circle
                    key={`pt-${i}`}
                    cx={p[0].toFixed(1)}
                    cy={p[1].toFixed(1)}
                    r="3"
                    fill={color}
                    style={{ pointerEvents: "none" }}
                />
            ))}
        </svg>
    );
};

export default Sparkline;
